import axiosInstance from "./axiosInstance";

export interface TourOperatorApi {
  tourOperatorId: number;
  itsNumber: string;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  officeName: string;
  mobileNumber: string;
  businessType: string;
  countryId: number;
  cityId: string;
  status: boolean | null;
}

export interface WalletLedgerApi {
  transactionDate: string;
  transactionType: string;
  referenceId: string;
  creditAmount: number;
  debitAmount: number;
  balanceAfter: number;
  remarks: string;
}

export interface WalletListApiResponse {
  items: WalletLedgerApi[];
  totalCount: number;
  pageNo: number;
  pageSize: number;
}

export interface WalletSummaryRecord {
  walletId: number;
  tourOperatorId: number;
  totalCredit: number;
  totalDebit: number;
  currentBalance: number;
  totalTransactions: number;
  lastTransactionOn: string | null;
}

export interface WalletSummaryApiResponse {
  totalWallets: number;
  grandTotalBalance: number;
  grandTotalCredit: number;
  grandTotalDebit: number;
  totalTransactions: number;
  records: WalletSummaryRecord[];
}

export interface BaseCurrencyApi {
  currencyId: number;
  currencyCode: string;
  currencyName: string;
  currencySymbol: string;
  exchangeRate: number;
  isBaseCurrency: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const getAuthHeader = () => { 
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getTourOperators = async (): Promise<TourOperatorApi[]> => {
  const res = await axiosInstance.get("/tour-operator", {
    headers: getAuthHeader(),
  });
  return res.data;
};

export const getWalletLedger = async (
  tourOperatorId: number
): Promise<WalletLedgerApi[]> => {
  const res = await axiosInstance.get(
    `/wallet/${tourOperatorId}/ledger`, {
      headers: getAuthHeader(),
    }
  );
  return res.data;
};

export const getWalletList = async (
  params: { pageNo: number; pageSize: number }
): Promise<WalletListApiResponse> => {
  const res = await axiosInstance.get("/wallet/list", {
    params,
    headers: getAuthHeader(),
  });
  return res.data;
};

export const getWalletSummary = async (): Promise<WalletSummaryApiResponse> => {
  const res = await axiosInstance.get("/wallet/summary", {
    headers: getAuthHeader(),
  });
  return res.data;
};

export const getBaseCurrency = async (): Promise<BaseCurrencyApi> => {
  const { data } = await axiosInstance.get("/Currency/base-currency", {
    headers: getAuthHeader(),
  });
  return data;
};

export const getWalletSummaryByTO = async (
  tourOperatorId: number
): Promise<WalletSummaryRecord> => {
  const res = await axiosInstance.get(
    `/wallet/summary/${tourOperatorId}`, {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const getApprovedTourOperators = async (): Promise<TourOperatorApi[]> => {
  const res = await axiosInstance.get("/tour-operator/approved", {
    headers: getAuthHeader(),
  });
  return res.data;
};

export const exportWalletLedger = async (tourOperatorId: number) => {
  const res = await axiosInstance.get(
    `/wallet/${tourOperatorId}/ledger/export`,
    {
      responseType: "blob", 
      headers: getAuthHeader(),
    }
  );

  return res.data;
};